// src/components/AppHeader/AppHeader.js

import React from 'react';
import styled from 'styled-components';
import { useMsal } from '@azure/msal-react';

const HeaderContainer = styled.header`
  width: 100%;
  background-color: #282c34;
  color: #f7f7f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 600px) {
    align-items: flex-start;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 1rem;
    margin-right: 30px;
  @media (max-width: 600px) {
    gap: 0.5rem;
    margin-top: 10px;
  }
`;

const Title = styled.h1`
  font-size: 1.5rem;
  margin: 0;
`;

const NavButton = styled.span`
    color: #f7f7f7;
    text-decoration: none;
    font-size: 1rem;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

const AppHeader = ({ showAboutModal, showContactModal }) => {
  const { instance } = useMsal(); // Access MSAL instance

  const handleLogout = () => {
    instance.logoutRedirect(); // Redirect the user to the Azure B2C logout page
  };

  return (
    <HeaderContainer>
      <Title>AI Consultant</Title>
      <Nav>
        <NavButton onClick={handleLogout}>Logout</NavButton>
        <NavButton onClick={showAboutModal}>About</NavButton>
        <NavButton onClick={showContactModal}>Contact</NavButton>
      </Nav>
    </HeaderContainer>
  );
};

export default AppHeader;
